import React, { Children, useEffect, useState } from 'react';
import { ConfigProvider } from 'antd';
import { Client, Provider, cacheExchange, fetchExchange, useQuery } from 'urql';
import { AuthConfig, authExchange } from '@urql/exchange-auth';

import Public from "./scenes/Public/Public";
import Private from './scenes/Private/Private';
import OAuthWrapper from 'OAuthWrapper';
import { API_URL_GRAPHQL } from '@common/config/environments';

function App() {

  const logout = () => {
    localStorage.removeItem('token');
    window.dispatchEvent(new Event("storage"));
  }

  const client = new Client({
    url: `${API_URL_GRAPHQL}/graphql`,
    exchanges: [
      cacheExchange,
      authExchange(async (utils: any) => {
        let token = await localStorage.getItem('token');

        const config: AuthConfig = {
          addAuthToOperation(operation) {
            if (!token) return operation;
            return utils.appendHeaders(operation, {
              Authorization: `Bearer ${token}`,
              'Apollo-Require-Preflight': 'true'
            });
          },
          didAuthError(error, _operation) {
            return error.response?.status === 401
          },
          async refreshAuth() { logout() },
          willAuthError(_operation) {
            return false
          },
        }

        return config;
      }),
      fetchExchange
    ]
  });

  const [isLogged, setIsLogged] = useState<boolean>(
    () => !!localStorage.getItem('token')
  );

  useEffect(() => {
    setIsLogged(!!localStorage.getItem('token'));

    window.addEventListener("storage", () => {
      setIsLogged(!!localStorage.getItem('token'));
    });

    return () => {
      window.removeEventListener("storage", () => { });
    };
  }, [])

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#ffffff',
          colorLink: '#5E8EB7',
          colorBgContainer: '#ffffff',
        },
      }}
    >
      <Provider value={client}>
        <OAuthWrapper>
          {isLogged && <Private />}
          {!isLogged && <Public />}
        </OAuthWrapper>
      </Provider>
    </ConfigProvider>
  )
}



export default App;
